import apiClient from "../core/HttpClient";
import { PaginationResult } from "../lib/definitions";
import GreetingOccasionImage from "../models/GreetingOccasionImage";

export default class GreetingOccasionImageService{
    url="/GreetingOccasionImages";

    async getGreetingOccasionImagesByCategoryId(categoryId: number,page: number, pageSize: number):Promise<PaginationResult<GreetingOccasionImage>>{
        return apiClient.get<PaginationResult<GreetingOccasionImage>>(`${this.url}/subcategory/${categoryId}`,{
            params: {
              page: page,
              pageSize: pageSize             
            }})
        .then((response) => {
            return response.data;
        });
    }

    

    async getGreetingOccasionImage(id: number){
        return apiClient.get(`${this.url}/${id}`).then((response) => {
            return response.data;
        });
    }
    async createGreetingOccasionImage(data: GreetingOccasionImage){
        return apiClient.post(this.url, data);
    }
    async uploadGreetingOccasionImage(categoryId: number, data: FormData){
        return apiClient.post(`${this.url}/subcategory/${categoryId}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
    async setIsComedy(id: number, isComedy: boolean){
        return apiClient.patch(`${this.url}/${id}/is-comedy?isComedy=${isComedy}`);
    }
    async setOccasionCollection(id: number, occasionCollectionId: number){
        return apiClient.patch(`${this.url}/${id}/occasion-collection?occasionCollectionId=${occasionCollectionId}`);
    }
    async setIsActive(id: number, isActive: boolean){
        return apiClient.patch(`${this.url}/${id}/is-active?isActive=${isActive}`);
    }
    async deleteGreetingOccasionImage(id: number){
        return apiClient.delete(`${this.url}/${id}`);
    }
}